import type { ReactNode } from "react";

import classes from "./pro-home.module.css";
import shell from "./studio2.module.css";

/** A section's heading row: its title, then its links on the right (the prototype's `.row`). */
export function SectionHead(props: { title: string; id: string; children?: ReactNode }) {
  return (
    <div className={classes.head}>
      <h2 id={props.id} className={classes.title}>
        {props.title}
      </h2>
      <span className={shell.grow} />
      {props.children}
    </div>
  );
}
